<template>
    <div class="m-popover-template" v-show="showPopover" ref="popoverElementRef">
        <div class="m-popover">
            <h3 v-if="title" class="m-popover-title">{{ title }}</h3>
            <div :class="`m-popover-body ${className}`">
                <slot></slot>
            </div>
        </div>
        <div class="arrow"></div>
    </div>
</template>

<style src="./popover.scss"></style>
<script lang="ts" src="./popover.ts"></script>
